import { AxiosRequestConfig } from "axios";
import { MD5, randomNmber, HmacSHA256 } from "@/tools";
import GlobalStateService from "@/services/global";

import { DEFAULT_SIGN_URL } from "./config";
// 接口签名
export const apiSign = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const query = config.params;
	const url = config.url || "";
	const isDefaultSign = DEFAULT_SIGN_URL.find((item) => {
		return url.indexOf(item) !== -1;
	});
	if (GlobalStateService.state.httpDomain) {
		config.baseURL = `${GlobalStateService.state.httpDomain}/ipc_web/`;
	} else {
		config.baseURL = `/ipc_web/`;
	}
	// query
	let queryString = "";
	if (query) {
		for (const key in query) {
			queryString = `${queryString}&${key}=${query[key] ?? ""}`;
		}
		queryString = queryString.slice(1, queryString.length);
	}

	// body
	const bodyMd5 = config.data ? MD5(JSON.stringify(config.data)) : "";
	const token = isDefaultSign ? "-" : GlobalStateService.state.userToken;
	const identity = isDefaultSign ? "-1" : GlobalStateService.state.userId;
	const t = new Date().getTime().toString();
	const nonce = MD5(randomNmber());

	const sign = HmacSHA256(identity + t + nonce + queryString + bodyMd5, token)
		.toString()
		.toUpperCase();
	if (config.headers) {
		config.headers.identity = identity;
		config.headers.t = t;
		config.headers.nonce = nonce;
		config.headers.sign = sign;
		config.headers.signVer = "1.1";
		config.headers.app = 8;
	}

	return config;
};
